export const contact = {
  title: 'Kontakt',
  routingNotice: 'Weiterleitung',
  routingText: 'Operative Anfragen richten Sie bitte direkt an die jeweilige Beteiligung.',
  email: 'E-Mail',
  address: 'Postanschrift',
  phone: 'Telefon',
  placeholders: {
    email: '[EMAIL]',
    address: '[ADDRESS]',
    phone: '[PHONE]'
  }
};